<div class="p-2 flex flex-col gap-2">
  @for (item of members; track $index) {
    <div
      (click)="!item.disabled && onConfirm(item)"
      [ngClass]="{
        'bg-slate-100': !item.disabled,
        'cursor-not-allowed': item.disabled,
        'cursor-pointer': !item.disabled,
        'hover:bg-slate-200': !item.disabled,
        'hover:bg-inherit': item.disabled,
        'text-slate-400': item.disabled
      }"
      class="p-2 flex flex-row rounded-md transition-colors"
    >
      <div class="flex items-center justify-center">
        <div class="relative p-2">
          <i class="fa-light fa-house-chimney-medical text-3xl"></i>
          @if (item.disabled) {
            <div
              class="absolute bottom-0 right-0 text-slate-800 rounded-full bg-white drop-shadow-md items-center justify-center flex w-6 h-6"
            >
              <span>
                <i class="fa-light fa-ban text-lg"></i>
              </span>
            </div>
          }
        </div>
      </div>

      <div class="flex flex-1 flex-col gap-0 p-2">
        <span
          class="font-semibold"
          [ngClass]="{ 'line-through': item.disabled }"
          >{{ item.tenant.name }}</span
        >

        <div class="flex flex-col gap-0">
          <span class="font-light">{{
            item.tenant.address | printAddress
          }}</span>
          <span class="font-light text-sm"
            >{{ item.tenant.phone }} -
            {{ item.tenant.plan.id | titlecase }}</span
          >
        </div>

        @if (item.disabled) {
          <div>
            <span class="italic text-xs text-slate-400">
              {{ "Sospeso per motivi amministrativi" | transloco }}
            </span>
          </div>
        }
      </div>
    </div>
  }
</div>
